<template>
	<v-container fluid pa-0 v-if="!$store.getters.progress" style="padding-bottom: 10%">
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="flex pa-0">
					<v-toolbar flat color="grey lighten-4">
						<v-toolbar-title class="pl-3 grey--text text--darken-4">{{ createTitleDialog }}</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>
					<v-divider></v-divider>
					<v-container fluid pt-3>
						<fields-generator
							:layoutClass="['row','wrap']" 
							:fieldsset.sync="fieldsset"
							:model="model"
							ref="fieldsgenerator"
							:selectChange="onChange"
						></fields-generator>
						<small class="pl-4">* Indica i campi obbligatori</small>
					</v-container>
				</v-card>
			</v-flex>

			<v-flex xs12 pt-3 v-if="crudRelation">
                <crud-table-relationship
					:title="crudRelation.title"
					:title-dialog="crudRelation.titleDialog"
					:info-relationship-url="crudRelation.infoRelationshipUrl"
					:children="relationModels"
					:key-of-model-cascade="crudRelation.keyOfModelCascade"
					:url-of-model-cascade="crudRelation.urlOfModelCascade"
					:key-of-model="crudRelation.keyOfModel"
					:default-input="crudRelation.relationDefaultInput"
					:params="{[crudRelation.params]: model[crudRelation.params]}"
					:footer-component="footerComponent"
                ></crud-table-relationship>
            </v-flex>

		</v-layout>

		<v-tooltip top>
			<v-fab-transition slot="activator">
				<v-btn
					@click.native="createModel"
					:loading="saved"
					color="primary"
					dark
					fixed
					bottom
					right
					fab>
					<v-icon>check</v-icon>
				</v-btn>
			</v-fab-transition>
			<span>Crea</span>
		</v-tooltip>
	</v-container>
</template>

<script>
import Vue from 'vue'
import FieldsGenerator from '@/components/FieldsGenerator'
import CrudTableRelationship from '@/components/CrudTableRelationship'

export default {
	name: 'create',
	components: {
		FieldsGenerator,
		CrudTableRelationship
	},
	props: {
		modelDef: String,
		redirect: Object,
		defaultInput: Object,
		urlAppend: {
			type: String,
			default: ''
		},
		footerComponent: String
	},

	data() {
		return {
			fieldsset: {},
			crudRelation: null,
			model: {},
			url: '',
			items: {},
			saved: false,
			relationModels: []
		}
	},

	created() {
		this.axios.get(this.modelDef + '-info/' + this.urlAppend).then(response => {
			// get body data
			this.infoData = response.data.info

			let urlWithAppend =          this.urlAppend != '' ? '/' + this.urlAppend + '/create' : '/create'

			this.axios.get(this.modelDef + urlWithAppend).then(response => {
				// get body data
				this.fieldsset = response.data.fields
				this.crudRelation = response.data.fields.crudRelation
				// Set defaultInput by back-end
				_.forEach(this.fieldsset.fields, (value, key) => {
					if (value.type === 'checkbox') {
						Vue.set(this.model, value.key, '')
					}
					if (value.default) {
						Vue.set(this.model, value.key, value.default)
					}
				})
				// Set defaultInput by previus component
				_.forEach(this.defaultInput, (value, key) => {
					Vue.set(this.model, key, value)
				})

				this.$store.commit('endProgress')
			},
			response => {
				// error callback
			})
		},
		response => {
			// error callback
		})
	},

	computed: {
		createTitleDialog() {
			return Vue.trans('new_' + this.infoData.modelTitle)
		}
	},

	methods: {
		// Call at change select option
		onChange(field, event) {
			this.$eventBusUtility.fieldsGeneratorConditions(field,
				event,
				this.fieldsset,
				this.model)
		},

		createModel() {
			this.$refs.fieldsgenerator.$validator
				.validateAll()
				.then(result => {
					if (!result) {
						return false
					}

					this.saved = true
					let urlWithAppend = this.urlAppend != '' ? '/' + this.urlAppend : ''

					if (this.crudRelation) {
						this.model[
							this.crudRelation.relationModelsKey
						] = this.relationModels
					}

					this.axios.post(this.modelDef + urlWithAppend, this.model).then(response => {
						// get body data
						this.model = {}
						this.saved = false

						this.$eventBusUtility.chooseRedirect(this.$router,
							response,
							this.redirect,
							this.modelDef)
					},
					response => {
						// error callback
					})
				})
				.catch(() => {})
		}
	}
}
</script>

<style>
.loading-dialog {
  background-color: #303030;
}
</style>
